// 详情
export const btnDetail = {
    id: 4,
    title: 'public.details',
    icon: 'el-icon-tickets',
    vHas: [],
    method: 'detailFn'
};

// 停用
export const btnStop = {
    id: 1,
    title: $t('public.stop'),
    icon: 'el-icon-video-pause',
    vHas: [],
    method: 'stopUseFn'
};

// 启用
export const btnStart = {
    id: 5,
    title: $t('integration.enable'),
    icon: 'el-icon-video-play',
    vHas: [],
    method: 'useAgainRowFn'
};

// 绑定历史
export const btnBindHistory = {
    id: 2,
    title: $t($t('integration.binding_history')),
    icon: 'iconfont icon-lishijilu',
    vHas: [],
    method: 'historyFn'
};

// 数据处理
export const btnDataHandle = {
    id: 3,
    title: $t($t('integration.data_processing')),
    icon: 'iconfont icon-spanner',
    vHas: [],
    method: 'dataHandleFn'
};

// 删除
export const btnDelete = {
    id: 6,
    title: $t('integration.delete'),
    icon: 'el-icon-delete',
    vHas: [],
    method: 'delRowFn'
};

// 未确认编辑
export const btnEdit = {
    id: 7,
    title: $t('public.edit'),
    icon: 'el-icon-edit-outline',
    vHas: [],
    method: 'editRowFn'
};

// 修改客户
export const btnEditScope = {
    id: 8,
    title: $t('public.edit'),
    icon: 'el-icon-edit-outline',
    vHas: [],
    method: 'editScopeRowFn'
};
